export const addPageTeam = (list) => {
  const teamList = document.querySelector('[data-team-list]');

  if (teamList)
    teamList.appendChild(list)
}